import { render, staticRenderFns } from "./CheckBoxLabelListItem.vue?vue&type=template&id=f28d6bd8&scoped=true&"
import script from "./CheckBoxLabelListItem.vue?vue&type=script&lang=js&"
export * from "./CheckBoxLabelListItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxLabelListItem.vue?vue&type=style&index=0&id=f28d6bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28d6bd8",
  null
  
)

export default component.exports